var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('feather-icon',{attrs:{"title":"Booth Map","icon":"MapIcon","svgClasses":['h-7 w-7 cursor-pointer']},on:{"click":_vm.boothMap}}),_c('feather-icon',{attrs:{"title":"Route Map","icon":"MapPinIcon","svgClasses":['h-7 w-7 ml-5 cursor-pointer']},on:{"click":_vm.routeMap}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }